import React, { Component } from 'react';
import styled from 'styled-components';

const FooterWrapper = styled.footer`
  grid-area: footer;
  text-align: center;
  background-color: #131313;
  position: fixed
  bottom: 0px;
  width: 100%;
`;

const FooterText = styled.p`
  line-height: 40px;
  @media (max-width: 700px) {
    font-size: 0.8rem;
  }
`;

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoggedIn: false };
  }

  render() {
    return (
      <FooterWrapper>
        <FooterText>
          Terms of Service &nbsp;|&nbsp; <a href="mailto:cue@djcoolhand.com">Feedback</a> &nbsp;
        </FooterText>
      </FooterWrapper>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js